module.exports = __webpack_public_path__ + "static/media/02@2x.6172c057.png";